module.exports = __webpack_public_path__ + "static/media/ubuntu.cad81bd4.svg";